import { render, staticRenderFns } from "./MatterFirstInstanceCourtList.vue?vue&type=template&id=3c2b0f24&"
import script from "./MatterFirstInstanceCourtList.vue?vue&type=script&lang=js&"
export * from "./MatterFirstInstanceCourtList.vue?vue&type=script&lang=js&"
import style0 from "./MatterFirstInstanceCourtList.vue?vue&type=style&index=0&id=3c2b0f24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports